// eslint-disable-next-line import/no-extraneous-dependencies
import '@babel/polyfill';
import 'window-location-origin';
// eslint-disable-next-line import/order
import configureStore from './configureStore';
// eslint-disable-next-line import/order
import './initDetectRTC';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { connect, Provider } from 'react-redux';
import { createBrowserHistory } from 'js/history';
import { Route, Routes } from 'react-router';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
//import { StripeProvider } from 'react-stripe-elements';
import { IntlProvider } from 'react-intl';
import 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/pl';
import 'moment/locale/de';
import 'moment/locale/tr';
import Loader from 'components/layout/Loader';
import Layout from './pages/Layout';
import Home from './pages/Home';
import EditorCC from './pages/EditorCC';
import Login from './pages/Login';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RentTermsOfService from './pages/RentTermsOfService';
import CookieUse from './pages/CookieUse';
import CancellationPolicy from './pages/CancellationPolicy';
import Imprint from './pages/Imprint';
import Signup from './pages/Signup';
import CompanySignupComplete from './pages/CompanySignupComplete';
import Contact from './pages/Contact';
import Locations from './pages/Locations';
import MarketplaceTerms from 'pages/MarketplaceTerms';
import OrderProcessingContract from 'pages/OrderProcessingContract';
import LocationDetails from './pages/LocationDetails';
import Signedup from './pages/Signedup';
import ForgotPassword from './pages/ForgotPassword';
import NewPasswordAfterReset from './pages/NewPasswordAfterReset';
import RenewPassword from './pages/RenewPassword';
import ApiDoc from './pages/ApiDoc';
import ApiDocDetails from './pages/ApiDocDetails';
import Pages from './pages/Pages';
import GoPro from './pages/GoPro';
import WidgetCart from './components/layout/cart/CartWizard';
import WidgetOrderComplete from './pages/Widget/OrderComplete';

{/*
  import WidgetFilledQuestionnaire from './pages/Widget/FilledQuestionnaire';
  import WidgetCheckoutInit from './pages/Widget/CheckoutInit';
  import WidgetCheckout from './pages/Widget/Checkout';
  import WidgetCheckoutError from './pages/Widget/CheckoutError';
  import WidgetShopSummary from './pages/Widget/ShopSummary';
  import WidgetItemDetails from './pages/Widget/ItemDetails';
  import MediaLibrary from 'pages/Account/MediaLibrary';
  import WidgetFavorites from './pages/Widget/Favorites';
*/}

import './clientStyles';
import globals from './globals';
import { provideStoreToNotification } from './helpers/notifications';
import BeforeUnload from './components/BeforeUnload';

const { debug, whiteLabelSettings } = globals;

const ClientAccountRoutes = React.lazy(() => import('./ClientAccountRoutes'));

const history = createBrowserHistory(debug);

const store = configureStore(history);
const routeLangPrefix = '/:lang?';

provideStoreToNotification(store);

function ClientRaw(props) {
  const { locale, messages } = props;
  return (

    <IntlProvider locale={locale} key={locale} messages={messages}>
      <DndProvider backend={HTML5Backend}>

        <Routes>
          <Route path={routeLangPrefix + '/termsMobile'} element={<TermsOfService />} />
          <Route path={routeLangPrefix + '/privacyMobile'} element={<PrivacyPolicy />} />
          <Route element={<Layout />}>
            <Route index path="/" element={<Home />} />
            <Route index path={routeLangPrefix} element={<Home routeFrom="default" />} />
            <Route path={routeLangPrefix + '/account/*'} element={
              <Suspense
                  fallback={
                    <div className="content">
                      <Loader />
                    </div>
                }
              >
                <ClientAccountRoutes />
              </Suspense>
            } />
            <Route path={routeLangPrefix + '/editor/:editionId'} element={<EditorCC />} />
            <Route index path={routeLangPrefix + '/login'} element={<Login />} />
            <Route path={routeLangPrefix + '/login/google'} element={<Login />} />
            <Route path={routeLangPrefix + '/login/facebook'} element={<Login />} />

            <Route path={routeLangPrefix + '/terms'} element={<TermsOfService />} />
            <Route path={routeLangPrefix + '/privacy'} element={<PrivacyPolicy />} />
            <Route path={routeLangPrefix + '/imprint'} element={<Imprint />} />
            <Route path={routeLangPrefix + '/signup'} element={<Signup />} />
            <Route path={routeLangPrefix + '/contact'} element={<Contact />} />
            <Route path={routeLangPrefix + '/termsofuse'} element={<MarketplaceTerms />} />
            <Route path={routeLangPrefix + '/orderprocessingcontract'} element={<OrderProcessingContract />} />
            <Route path={routeLangPrefix + '/signedup'} element={<Signedup />} />
            <Route index path={routeLangPrefix + '/forgotpassword'} element={<ForgotPassword />} />
            <Route path={routeLangPrefix + '/forgotpassword/:token'} element={<NewPasswordAfterReset />} />
            <Route index path={routeLangPrefix + '/renewpassword'} element={<RenewPassword />} />
            <Route path={routeLangPrefix + '/renewpassword/:token'} element={<RenewPassword />} />
            <Route exact path={routeLangPrefix + '/docs'} element={<ApiDoc />} /> {/* what's that? CodeAN-999 */}
            <Route path={routeLangPrefix + '/docs/:groupId'} element={<ApiDocDetails />} /> {/* what's that? */}
            <Route path={routeLangPrefix + '/pages/:slug'} element={<Pages />} />

            {/* in use? */}
            <Route path={routeLangPrefix + '/rentTerms'} element={<RentTermsOfService />} /> {/* not in use. needed? */}
            <Route path={routeLangPrefix + '/cancellationPolicy'} element={<CancellationPolicy />} /> {/* not in use. needed? */}
            <Route path={routeLangPrefix + '/companySignupComplete'} element={<CompanySignupComplete />} /> {/* not in use. needed? */}
            <Route path={routeLangPrefix + '/cookie'} element={<CookieUse />} /> {/* not in use. needed? */}
            <Route path={routeLangPrefix + '/locations'} element={<Locations />} /> {/* not in use. needed? */}
            <Route path={routeLangPrefix + '/standorte'} element={<Locations />} /> {/* not in use. needed? */}
            <Route path={routeLangPrefix + '/locations/:locationId-:locationName'} element={<LocationDetails />} /> {/* not in use. needed? */}
            <Route path={routeLangPrefix + '/standorte/:locationId-:locationName'} element={<LocationDetails />} /> {/* not in use. needed? */}
            <Route path={routeLangPrefix + '/gopro'} element={<GoPro />} /> {/* not in use. needed? */}

            {/* widget in use */}
            <Route path={routeLangPrefix + '/cart'} element={<WidgetCart />} />
            <Route path={routeLangPrefix + '/warenkorb'} element={<WidgetCart />} />
            <Route path={routeLangPrefix + '/orderComplete'} element={<WidgetOrderComplete />} />


            {/* widgets in use? */}
            {/*
              <Route
                path={routeLangPrefix + '/questionnaires/:filledQuestionnaireToken'}
                element={<WidgetFilledQuestionnaire />}
              />
              <Route exact path={routeLangPrefix + '/checkout/init'} element={<WidgetCheckoutInit />} />
              <Route exact path={routeLangPrefix + '/checkout/error'} element={<WidgetCheckoutError />} />
              <Route exact path={routeLangPrefix + '/checkout'} element={<WidgetCheckout />} />
              <Route path={routeLangPrefix + '/checkout/overview'} element={<WidgetCheckout />} />
              <Route path={routeLangPrefix + '/checkout/personal'} element={<WidgetCheckout />} />
              <Route path={routeLangPrefix + '/checkout/services'} element={<WidgetCheckout />} />
              <Route path={routeLangPrefix + '/checkout/shipping'} element={<WidgetCheckout />} />
              <Route path={routeLangPrefix + '/checkout/payment'} element={<WidgetCheckout />} />
              <Route exact path={routeLangPrefix + '/shop'} element={<WidgetShopSummary />} />
              <Route
                exact
                path={routeLangPrefix + '/shop/category-:categoryName-:category'}
                element={<WidgetShopSummary />}
              />
              <Route
                exact
                path={routeLangPrefix + '/shop/kategorie-:categoryName-:category'}
                element={<WidgetShopSummary />}
              />
              <Route path={routeLangPrefix + '/shop/:slug'} element={<WidgetItemDetails />} />
              <Route path={routeLangPrefix + '/(favorites|favoriten)'} element={<WidgetFavorites />} />
            */}

          </Route>
        </Routes>

      </DndProvider>
    </IntlProvider>
  );
}

const mapStateToProps = ({
  intl: {
    locale,
    messages: { messages },
  },
}) => ({ locale, messages });

const Client = connect(mapStateToProps)(ClientRaw);

const root = ReactDOM.createRoot(document.getElementById('app'));
root.render(
  <Provider store={store}>
    <BeforeUnload>
      <ReduxRouter history={history}>
        <Client />
      </ReduxRouter>
    </BeforeUnload>
  </Provider>
);
